<script type="ts">
    import { ToastNotification } from "carbon-components-svelte";
    import { stores } from "@nubolab-ffwd/svelte-fluent/src/internal/FluentProvider.svelte";

    export let toasts = [];
    export let onRemove;

	const { getTranslation } = stores();    

</script>

<aside class="toast-container">
    {#each toasts as toast}
    <ToastNotification
        lowContrast
        kind={toast.kind}
        title={$getTranslation(toast.title).value}
        subtitle={$getTranslation(toast.subtitle).value}
        timeout={2000}
        on:close={() => onRemove(toast)}
    />
    {/each}
</aside>

<style type="text/scss">
    .toast-container {
		position: fixed;
		top: 0;
		right: 0;
		z-index: 9999;
		display: flex;
		flex-direction: column;
		align-items: center;
	}
</style>